module.exports = __webpack_public_path__ + "img/no_result.6bc19622.png";